// extracted by mini-css-extract-plugin
export default {"cookies":"Cookies_cookies__Bww4f","accept":"Cookies_accept__ua1fs"};